import React, { Component } from "react"
import GET_PAGE from "../../graphql/getPage.graphql"
import ApolloQueryHandler from "../../shared/apolloQueryHandler"
import { Query } from "react-apollo"

import "./newsletter.scss"

class Newsletter extends Component {
  constructor(props) {
    super(props)
  }

  redirectToCurrentNewsletter = () => {
    let { newsletterRedirect } = this.props.data
    if (this.props.data.newsletterRedirect != this.props.location.pathname) {
      if (
        window &&
        newsletterRedirect &&
        newsletterRedirect !== "/newsletter"
      ) {
        this.props.history.push(newsletterRedirect)
      }
    }
  }

  componentDidMount = () => {
    this.props.trackPage("newsletter signup", {
      authenticated: false,
    })
    this.redirectToCurrentNewsletter()
  }

  render() {
    return null
  }
}

const NewsletterWithData = (componentProps) => {
  return (
    <Query
      query={GET_PAGE}
      variables={{ slug: "/" }}
      fetchPolicy="network-only"
    >
      {(queryProps) => {
        return (
          <ApolloQueryHandler {...queryProps} {...componentProps}>
            {(props) => {
              return <Newsletter {...props} />
            }}
          </ApolloQueryHandler>
        )
      }}
    </Query>
  )
}

export default NewsletterWithData
